<template>
    <div class="card card-default">
        <div class="card-header">
            Update Team Wide Global UTM parameters
        </div>

        <div class="card-body">
            <!-- Success Message -->
            <div class="alert alert-success" v-if="form.successful">
                Your team UTM settings have been updated!
            </div>

            <form role="form">
                <!-- use UTM parameters check -->
                <div class="form-group row" :class="{'has-error': form.errors.has('use_global_utm_parameters')}">
                    <label class="col-md-4 col-form-label text-md-right">Enable Team Wide Global UTM Parameters</label>

                    <div class="col-md-6">
                        <input type="checkbox" name="use_global_utm_parameters" v-model="form.use_global_utm_parameters" />
                        <span class="help-block" v-show="form.errors.has('global_utm_parameters')">
                            {{ form.errors.get('use_global_utm_parameters') }}
                        </span>
                    </div>
                </div>

                <!-- UTM parameters -->
                <div v-if="form.use_global_utm_parameters" class="form-group row" :class="{'has-error': form.errors.has('global_utm_parameters')}">
                    <label class="col-md-4 col-form-label text-md-right">Paste Global UTM parameters here</label>

                    <div class="col-md-6">
                        <textarea class="form-control" name="global_utm_parameters" v-model="form.global_utm_parameters"></textarea>
                        <span class="help-block" v-show="form.errors.has('global_utm_parameters')">
                            {{ form.errors.get('global_utm_parameters') }}
                        </span>
                    </div>
                </div>

                <!-- Update Button -->
                <div class="form-group row mb-0">
                    <div class="offset-md-4 col-md-6">
                        <button type="submit" class="btn btn-primary"
                                @click.prevent="update"
                                :disabled="form.busy">
                            Update
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    props: ['team'],

    data() {
        return {
            form: new SparkForm({
                global_utm_parameters: '',
                use_global_utm_parameters: false,
            }),
        };
    },

    mounted() {
        this.form.use_global_utm_parameters = Boolean(this.team.use_global_utm_parameters);
        this.form.global_utm_parameters = this.team.global_utm_parameters;

        Bus.$on(`sparkFormUpdated.${this.form.sparkFormId}`, this.$forceUpdate)
    },

    methods: {
        update() {
            if (
                typeof this.form.global_utm_parameters === 'string' ||
                this.form.global_utm_parameters instanceof String
            ) {
                this.form.global_utm_parameters = this.form.global_utm_parameters.trim();
                if (this.form.global_utm_parameters.length === 0) this.global_utm_parameters = null;
            }

            Spark.put(`/settings/teams/${this.team.id}/name`, this.form).then(
                () => {
                    Bus.$emit('updateTeam');
                    Bus.$emit('updateTeams');
                },
                () => {
                    this.form.global_utm_parameters = this.team.global_utm_parameters;
                }
            );
        },
    },
}
</script>
